import React from 'react';
import { Icon, Popup } from 'semantic-ui-react';
import { EstateUnit, EstateUnitStatusEnum } from '../../../types/EstateUnit';
import {
  UnitCardActions,
  UnitCardContainer,
  UnitCardContent,
  UnitCardDestructiveAction,
  UnitCardIcon,
  UnitCardLinkAction,
  UnitCardLocation,
  UnitCardMain,
  UnitCardMainStatic,
  UnitCardName
} from '../styles';

type EstateUnitCardProps = {
  unit: EstateUnit;
  isSelected?: boolean;
  isSelectable?: boolean;
  canManage?: boolean;
  onSelect?: (unit: EstateUnit) => void;
  onEdit: (unit: EstateUnit) => void;
  onToggleStatus: (unit: EstateUnit, action: 'ACTIVE' | 'INACTIVE') => void;
};

const EstateUnitCard: React.FC<EstateUnitCardProps> = ({
  unit,
  isSelected = false,
  isSelectable = false,
  canManage = false,
  onSelect,
  onEdit,
  onToggleStatus
}) => {
  const isActive = unit.status === EstateUnitStatusEnum.active;

  const handleCardClick = () => {
    if (isSelectable && onSelect) {
      onSelect(unit);
    }
  };

  const cardContent = (
    <>
      <UnitCardIcon>
        <Icon name="building outline" />
      </UnitCardIcon>

      <UnitCardContent>
        <UnitCardName>{unit.name}</UnitCardName>
        <UnitCardLocation>
          {unit.city} - {unit.state}
        </UnitCardLocation>
      </UnitCardContent>
    </>
  );

  return (
    <UnitCardContainer
      $isSelected={isSelected}
      $isInactive={!isActive}
      $isSelectable={isSelectable}
    >
      {isSelectable ? (
        <UnitCardMain
          type="button"
          onClick={handleCardClick}
          aria-pressed={isSelected}
        >
          {cardContent}
        </UnitCardMain>
      ) : (
        <UnitCardMainStatic>{cardContent}</UnitCardMainStatic>
      )}

      {canManage && (
        <UnitCardActions>
          <Popup
            content="Editar"
            position="top center"
            trigger={
              <UnitCardLinkAction
                type="button"
                onClick={() => onEdit(unit)}
                aria-label={`Editar unidade ${unit.name}`}
              >
                <Icon name="edit outline" aria-hidden="true" />
              </UnitCardLinkAction>
            }
          />

          {isActive ? (
            <Popup
              content="Inativar"
              position="top center"
              trigger={
                <UnitCardDestructiveAction
                  type="button"
                  onClick={() => onToggleStatus(unit, 'INACTIVE')}
                  aria-label={`Inativar unidade ${unit.name}`}
                >
                  <Icon name="ban" aria-hidden="true" />
                </UnitCardDestructiveAction>
              }
            />
          ) : (
            <Popup
              content="Ativar"
              position="top center"
              trigger={
                <UnitCardLinkAction
                  type="button"
                  onClick={() => onToggleStatus(unit, 'ACTIVE')}
                  aria-label={`Ativar unidade ${unit.name}`}
                >
                  <Icon name="check" aria-hidden="true" />
                </UnitCardLinkAction>
              }
            />
          )}
        </UnitCardActions>
      )}
    </UnitCardContainer>
  );
};

export default EstateUnitCard;
